import { SnippetSrc } from '@fullstory/snippet';

export default SnippetSrc;
